/**
 * Ícone e cor de cada módulo, em um lugar só.
 *
 * Os seletores de permissão filtram a lista vinda da API por este mapa
 * (`filter(p => MODULE_CONFIG[p])`), então um módulo ausente aqui simplesmente
 * some da tela mesmo existindo no backend. Quando havia uma cópia deste objeto
 * em cada seletor, criar um módulo novo exigia lembrar de todas elas.
 *
 * A ordem das chaves também é a ordem canônica dos cards na tela.
 */
export const MODULE_CONFIG = {
    DASHBOARD:     { icon: 'fa-solid fa-chart-pie',           color: '#8b5cf6' },
    REPORTS:       { icon: 'fa-solid fa-chart-pie',           color: '#0d9488' },
    REGISTRATION:  { icon: 'fa-solid fa-address-book',        color: '#4CAF50' },
    APPOINTMENT:   { icon: 'fa-solid fa-calendar-check',      color: '#2196F3' },
    STOCK_CONTROL: { icon: 'fa-solid fa-boxes-stacked',       color: '#FF9800' },
    CASH_FLOW:     { icon: 'fa-solid fa-chart-line',          color: '#00BCD4' },
    SALES:         { icon: 'fa-solid fa-cart-shopping',       color: '#E91E63' },
    PERFORMANCE:   { icon: 'fa-solid fa-chart-simple',        color: '#607D8B' },
    GAMIFICATION:  { icon: 'fa-solid fa-trophy',              color: '#FFC107' },
    SUBSCRIPTION:  { icon: 'fa-solid fa-rotate',              color: '#3F51B5' },
    WHATSAPP:      { icon: 'fa-brands fa-whatsapp',           color: '#25D366' },
};

export default MODULE_CONFIG;
